import {
  EndorsementFailureReason,
  EndorsementUnderwritingDecision,
} from "@covertree/agent-portal-graphql";

import { IssueEndorsementStatus } from "./types";

const ISSUE_STATUS_BY_FAILURE_REASON: Record<
  EndorsementFailureReason,
  IssueEndorsementStatus
> = {
  [EndorsementFailureReason.PaymentFailed]: IssueEndorsementStatus.PaymentError,
  [EndorsementFailureReason.IssuanceFailed]: IssueEndorsementStatus.GlobalError,
  [EndorsementFailureReason.ErrorOccurred]: IssueEndorsementStatus.GlobalError,
  [EndorsementFailureReason.InvalidState]: IssueEndorsementStatus.GlobalError,
  [EndorsementFailureReason.ActiveRenewal]:
    IssueEndorsementStatus.ActiveRenewalError,
  [EndorsementFailureReason.DraftRenewal]:
    IssueEndorsementStatus.DraftRenewalError,
  [EndorsementFailureReason.NonRenewalIssued]:
    IssueEndorsementStatus.NonRenewalIssuedError,
  [EndorsementFailureReason.PolicyCancelled]:
    IssueEndorsementStatus.PolicyCancelledError,
  [EndorsementFailureReason.PolicyExpired]:
    IssueEndorsementStatus.PolicyExpiredError,
  [EndorsementFailureReason.ConflictingEndorsement]:
    IssueEndorsementStatus.ConflictingEndorsementError,
  [EndorsementFailureReason.UnderwritingReferred]:
    IssueEndorsementStatus.UnderwritingReferredError,
  [EndorsementFailureReason.UnderwritingDeclined]:
    IssueEndorsementStatus.UnderwritingDeclinedError,
};

export const mapFailureReasonToIssueStatus = (
  reason?: EndorsementFailureReason
) => (reason ? ISSUE_STATUS_BY_FAILURE_REASON[reason] : undefined);

const ISSUE_STATUS_BY_DECISION: Partial<
  Record<EndorsementUnderwritingDecision, IssueEndorsementStatus>
> = {
  [EndorsementUnderwritingDecision.Referred]:
    IssueEndorsementStatus.UnderwritingReferredError,
  [EndorsementUnderwritingDecision.Declined]:
    IssueEndorsementStatus.UnderwritingDeclinedError,
};

export const mapUnderwritingDecisionToIssueStatus = (
  decision?: EndorsementUnderwritingDecision
) => (decision ? ISSUE_STATUS_BY_DECISION[decision] : undefined);
